<template>
  <a-form-model ref="verificationForm" :model="company" :rules="rules" layout="vertical">
    <a-row :gutter="16">
      <a-col :span="18">
        <label
          >We have sent a verification code to <strong>{{ this.company.email }}</strong
          >, please enter below</label
        >
        <a-form-model-item prop="verificationCode">
          <a-input ref="verification" placeholder="Verification Code" v-model="company.verificationCode" />
        </a-form-model-item>
      </a-col>
    </a-row>
  </a-form-model>
</template>

<script>
import { helper } from '../../../Utilities/helper';
import * as messages from '../../../assets/Json/messages.json';

export default {
  mounted() {
    this.$refs.verification.focus();
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    events: { type: Object, required: true },
    validate: Boolean,
  },
  data() {
    return {
      rules: {
        verificationCode: [
          { required: true, message: messages.verifyCodeErrorMessage, trigger: 'change' },
          {
            validator: helper.verifyCodeFormatValidator,
            trigger: ['change', 'blur'],
          },
          {
            validator: helper.verifyCodeValidator,
            trigger: 'blur',
            transform: (value) => {
              return { verificationCode: value, registrationId: this.company.registrationId };
            },
          },
        ],
      },
    };
  },
  watch: {
    validate(newVal) {
      if (newVal) {
        this.$emit(this.events.validationStarted);
        this.$refs.verificationForm.validate((valid) => {
          this.$emit(this.events.validationEnded);
          if (valid) {
            this.$emit(this.events.moveNext, { source: 'Verification', isValid: true });
          }
        });
      }
    },
  },
  computed: {
    label() {
      return `We have sent you a verification code to ${this.company.email}, please enter it below`;
    },
  },
};
</script>

<style lang="scss">
</style>